<div class="update-appt">
  <p class="font-bold">Would you like to send update email to customer?</p>
  <div class="update-appt-msg">
    <textarea autocomplete="off" autocorrect="off" spellcheck="false" class="update-appt-content" name="content"
      cols="30" rows="6" [(ngModel)]="content" appAutofocus></textarea>
  </div>
  <div class="update-appt-action">
    <button (click)="onClose('dismiss')" class="btn font-bold">Dismiss</button>
    <button [disabled]="!isDataReceived" [ngClass]="{'not-allowed': !isDataReceived}" (click)="onClose('dontsend')"
      class="btn font-bold">Don't Send</button>
    <button [disabled]="!isDataReceived" [ngClass]="{'not-allowed': !isDataReceived}" (click)="onClose('send')"
      class="btn btn-send font-bold">Send</button>
  </div>
</div>
